import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { getContrastText, normalizeHexColor } from '../../utils/clientTags';

export default function ClientTagChip({ tag, auto = false, size = 'small', title, sx, onDelete, ...chipProps }) {
  if (!tag?.name) return null;

  const bgcolor = normalizeHexColor(tag.color);
  const isAuto = auto || tag.source === 'rule';

  const chip = (
    <Chip
      label={tag.name}
      size={size}
      variant={isAuto ? 'outlined' : 'filled'}
      onDelete={onDelete}
      sx={{
        fontWeight: 500,
        ...(isAuto
          ? {
            borderColor: bgcolor,
            color: bgcolor,
            bgcolor: 'transparent',
          }
          : {
            bgcolor,
            color: getContrastText(bgcolor),
            border: 'none',
          }),
        ...sx,
      }}
      {...chipProps}
    />
  );

  if (isAuto && title) {
    return (
      <Tooltip title={title} arrow>
        {chip}
      </Tooltip>
    );
  }

  return chip;
}
